import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const SUPPORTED = ["en", "ur", "sd"];

export const normalizeLanguage = (lng) => {
  if (!lng || typeof lng !== "string") return "en";
  const base = lng.split("-")[0].toLowerCase();
  return SUPPORTED.includes(base) ? base : "en";
};

const getInitialLanguage = () => normalizeLanguage(localStorage.getItem("language"));

const enServicesCards = [
  { title: "POS Setup", desc: "Quick deployment for billing, invoicing, and inventory workflow." },
  { title: "Inventory Control", desc: "Smart stock tracking with purchase and vendor management." },
  { title: "Accounts Management", desc: "Sales, expenses, and profit visibility in one dashboard." },
  { title: "Data Migration", desc: "Move existing records safely into Business Finance software." },
  { title: "Staff Training", desc: "Practical onsite sessions for teams and administrators." },
  { title: "Technical Support", desc: "Reliable assistance for troubleshooting and updates." },
];

const urServicesCards = [
  { title: "پی او ایس سیٹ اپ", desc: "بلنگ، انوائسنگ، اور انوینٹری ورک فلو کے لیے فوری تعینات۔" },
  { title: "انوینٹری کنٹرول", desc: "خریداری اور وینڈر مینجمنٹ کے ساتھ اسمارٹ اسٹاک ٹریکنگ۔" },
  { title: "اکاؤنٹس مینجمنٹ", desc: "ایک ڈیش بورڈ میں سیلز، اخراجات، اور منافع کی وضاحت۔" },
  { title: "ڈیٹا مائیگریشن", desc: "موجودہ ریکارڈز کو محفوظ طریقے سے بزنس فائنانس میں منتقل کریں۔" },
  { title: "اسٹاف ٹریننگ", desc: "ٹیموں اور منتظمین کے لیے عملی آن بورڈنگ سیشنز۔" },
  { title: "ٹیکنیکل سپورٹ", desc: "ٹربل شوٹنگ اور اپ ڈیٹس کے لیے قابل اعتماد مدد۔" },
];

const sdServicesCards = [
  { title: "پي او ايس سيٽ اپ", desc: "بلنگ، انوائسنگ، ۽ انوينٽري ورڪ فلو لاءِ تڪڙي تعينات." },
  { title: "انوينٽري ڪنٽرول", desc: "خريداري ۽ وينڊر مينيجمينٽ سان اسمارٽ اسٽاڪ ٽريڪنگ." },
  { title: "اڪائونٽس مينيجمينٽ", desc: "هڪ ڊيش بورڊ ۾ سيلز، خرچ، ۽ منافع جي وضاحت." },
  { title: "ڊيٽا مائيگريشن", desc: "موجوده رڪارڊز کي محفوظ طريقي سان بزنس فنانس ۾ منتقل ڪريو." },
  { title: "اسٽاف ٽريننگ", desc: "ٽيمن ۽ منتظمين لاءِ عملي آن بورڊنگ سيشن." },
  { title: "ٽيڪنيڪل سپورٽ", desc: "ٽربل شوٽنگ ۽ اپ ڊيٽس لاءِ قابل اعتماد مدد." },
];

const enFeatureItems = [
  "Accounts",
  "Invoicing",
  "Items Add, Delete Update",
  "Categories Add, Delete Update",
  "Vendors Add, Delete Update",
  "Bar Code Generate",
  "Refund option only admin",
  "Barcode Scaning",
  "Sales Search by Date",
  "Stock Management",
  "Purchase Option",
  "Customer Data",
  "Customer Bill",
];

const urFeatureItems = [
  "اکاؤنٹس",
  "انوائسنگ",
  "آئٹمز شامل، حذف، اپ ڈیٹ",
  "کیٹیگریز شامل، حذف، اپ ڈیٹ",
  "وینڈرز شامل، حذف، اپ ڈیٹ",
  "بار کوڈ جنریٹ",
  "ریفنڈ صرف ایڈمن",
  "بار کوڈ اسکیننگ",
  "تاریخ کے مطابق سیلز تلاش",
  "اسٹاک مینجمنٹ",
  "خریداری کا اختیار",
  "کسٹمر ڈیٹا",
  "کسٹمر بل",
];

const sdFeatureItems = [
  "اڪائونٽس",
  "انوائسنگ",
  "آئٽمز شامل، ختم، اپ ڊيٽ",
  "ڪيٽيگريز شامل، ختم، اپ ڊيٽ",
  "وينڊرز شامل، ختم، اپ ڊيٽ",
  "بار ڪوڊ جنريٽ",
  "ريفنڊ صرف ايڊمن",
  "بار ڪوڊ اسڪيننگ",
  "تاريخ مطابق سيلز ڳولها",
  "اسٽاڪ مينيجمينٽ",
  "خريداري جو اختيار",
  "ڪسٽمر ڊيٽا",
  "ڪسٽمر بل",
];

const enReportItems = [
  "Daily Summary",
  "Item Wise Summary",
  "Refund Summary",
  "Expense Summary",
  "Stock Report",
  "Vendor Report",
  "Monthly Profit & Lose Report",
];

const urReportItems = [
  "روزانہ خلاصہ",
  "آئٹم وار خلاصہ",
  "ریفنڈ خلاصہ",
  "اخراجات خلاصہ",
  "اسٹاک رپورٹ",
  "وینڈر رپورٹ",
  "ماہانہ منافع و نقصان رپورٹ",
];

const sdReportItems = [
  "روزاني خلاصو",
  "آئٽم وار خلاصو",
  "ريفنڊ خلاصو",
  "خرچ خلاصو",
  "اسٽاڪ رپورٽ",
  "وينڊر رپورٽ",
  "مهيني منافع و نقصان رپورٽ",
];

const enMarquee = [
  { icon: "🛒", name: "Mini Mart" },
  { icon: "🏪", name: "General Stores" },
  { icon: "💊", name: "Pharmacy" },
  { icon: "🥖", name: "Bakery" },
  { icon: "🥛", name: "Milk Shop" },
  { icon: "🛢️", name: "Oil Depo" },
  { icon: "🍽️", name: "Restaurant" },
  { icon: "🍖", name: "BBQ Fast Foods" },
  { icon: "🚚", name: "Distribution" },
  { icon: "🎨", name: "Paint Shop" },
  { icon: "🩺", name: "Clinic Solution" },
  { icon: "💇", name: "Hair Salon" },
  { icon: "👔", name: "Cloth Shop" },
  { icon: "📚", name: "Stationary Books Shop" },
  { icon: "🚗", name: "Autoparts" },
  { icon: "🏭", name: "Crash Plant" },
  { icon: "🔧", name: "Hardware & Sanitary" },
  { icon: "💻", name: "Retail & Wholesale Software" },
];

const urMarquee = [
  { icon: "🛒", name: "چھوٹا مارٹ" },
  { icon: "🏪", name: "جنرل اسٹورز" },
  { icon: "💊", name: "فارمیسی" },
  { icon: "🥖", name: "بیکری" },
  { icon: "🥛", name: "دودھ کی دکان" },
  { icon: "🛢️", name: "تیل ڈیپو" },
  { icon: "🍽️", name: "ریستوران" },
  { icon: "🍖", name: "بی بی کی فاسٹ فوڈز" },
  { icon: "🚚", name: "ڈسٹریبیوشن" },
  { icon: "🎨", name: "پینٹ شاپ" },
  { icon: "🩺", name: "کلینک حل" },
  { icon: "💇", name: "ہیئر سیلون" },
  { icon: "👔", name: "کپڑے کی دکان" },
  { icon: "📚", name: "سٹیشنری کتابوں کی دکان" },
  { icon: "🚗", name: "آٹو پارٹس" },
  { icon: "🏭", name: "کریش پلانٹ" },
  { icon: "🔧", name: "ہارڈویئر اور سینیٹری" },
  { icon: "💻", name: "ریٹیل اور ہول سیل سافٹ ویئر" },
];
const sdMarquee = [
  { icon: "🛒", name: "ننڍو مارٽ" },
  { icon: "🏪", name: "جنرل اسٽورز" },
  { icon: "💊", name: "فارميسي" },
  { icon: "🥖", name: "بیکري" },
  { icon: "🥛", name: "دودھ جي دوکان" },
  { icon: "🛢️", name: "تيل ڊيپو" },
  { icon: "🍽️", name: "ريستوران" },
  { icon: "🍖", name: "بي بي ڪي فاسٽ فوڊز" },
  { icon: "🚚", name: "ڊسٽريبيوشن" },
  { icon: "🎨", name: "پينٽ شاپ" },
  { icon: "🩺", name: "ڪلينڪ حل" },
  { icon: "💇", name: "هيئر سيلون" },
  { icon: "👔", name: "ڪپڙن جي دوکان" },
  { icon: "📚", name: "اسٽيشنري ڪتابن جي دوکان" },
  { icon: "🚗", name: "آٽو پارٽس" },
  { icon: "🏭", name: "ڪريش پلانٽ" },
  { icon: "🔧", name: "هارڊويئر ۽ سينيٽري" },
  { icon: "💻", name: "ريٽيل ۽ هول سيل سافٽ ويئر" },
];

const enScreenshotNames = [
  "Login",
  "Sales Invoice",
  "Purchase Voucher",
  "Reciept Voucher",
  "Accounts Transactions",
  "Party Ledger",
  "Item Ledger",
  "Income Statement",
];

const urScreenshotNames = [
  "لاگ ان",
  "سیلز انوائس",
  "خریداری واؤچر",
  "رسید واؤچر",
  "اکاؤنٹس لین دین",
  "پارٹی لیجر",
  "آئٹم لیجر",
  "انکم اسٹیٹمنٹ",
];

const sdScreenshotNames = [
  "لاگ ان",
  "سيلز انوائس",
  "خريداري وائوچر",
  "رسيد وائوچر",
  "اڪائونٽس لين ڏن",
  "پارٽي ليجر",
  "آئٽم ليجر",
  "انڪم اسٽيٽمينٽ",
];

const commonBundle = (cards, featureItems, reportItems, marquee, screenshotNames) => ({
  nav: {
    services: "Services",
    features: "Features",
    download: "Download",
    about: "About",
    support: "Support",
  },
  home: {
    ourServices: "OUR SERVICES",
    promoQuote: "Provide Your Business in Quality",
    downloadSuffix: "(32/64-bit)",
    marquee,
  },
  services: {
    title: "Services",
    intro:
      "Complete business software services for retail, wholesale, and distribution with setup, training, and after-sales technical support.",
    cards,
  },
  features: {
    title: "Features",
    intro:
      "Multi-Purpose Point Of Sale Software For All Type of businesses. At Affordable Prices In This Time Of Increasing Inflation Business Finance is Collaborating With Businesses to Grow with.",
    coreFeatures: "Core Features",
    reports: "Reports",
    included: "Included",
    bottomBanner:
      "Business Finance is built to help your business stay organized, profitable, and ready to scale.",
    highlight1Title: "Smart Billing",
    highlight1Desc: "Fast invoice generation with barcode and secure refund control.",
    highlight2Title: "Live Inventory",
    highlight2Desc: "Real-time stock movement and low stock awareness.",
    highlight3Title: "Business Insights",
    highlight3Desc: "Daily and monthly reports for better decisions.",
    featureItems,
    reportItems,
  },
  aboutPage: {
    founderProfile: "Founder Profile",
    founderRole: "Business Finance Software Consultant",
    founderBio:
      "We build practical and reliable software solutions for growing businesses. Our focus is to simplify daily operations and help owners make better decisions through clear data and smart automation.",
    ourAim: "Our Aim",
    ourAimParagraph:
      "Our aim is to empower retailers, wholesalers, and distributors with affordable and intelligent business management tools. We are committed to helping companies improve inventory control, sales performance, and financial clarity with confidence.",
    companyExperienceTitle: "Company Experience",
    companyExperienceBody:
      "We have 10+ years of professional experience in business software solutions with multi satisfied customers across retail, wholesale, and distribution sectors.",
    yearsExperience: "Years Experience",
    happyBusinesses: "Happy Businesses",
    customerSupport: "Customer Support",
  },
  downloadPage: {
    title: "Download",
  },
  supportPage: {
    title: "Support",
    heading: "Customer support for your business",
    intro:
      "Submit the form for registration, installation, or technical help. We'll respond as soon as we can.",
    nameLabel: "Name*",
    emailLabel: "Email*",
    phoneLabel: "Phone*",
    reasonLabel: "Reason To Contact*",
    productLabel: "Choose Product/Service*",
    uploadLabel: "Upload Issue Screenshot (Optional)",
    messageLabel: "Message*",
    sendMessage: "Send Message",
    placeholderName: "Enter your name",
    placeholderEmail: "Enter your email",
    placeholderPhone: "Enter phone number",
    placeholderMessage: "Write your message",
    selectReason: "Select reason",
    inquiry: "Inquiry",
    contact: "Contact",
    selectProduct: "Select product/service",
    desktopApplication: "Desktop Application",
    mobileApplication: "Mobile Application",
    website: "Website",
    mapTitle: "Khairpur Mirs Map",
    supportAlt: "24/7 customer support",
  },
  footer: {
    locationMap: "Location Map",
    companyExperience: "Company Experience",
    companyExperienceText:
      "We have 10+ years of professional experience in business software solutions with multi satisfied customers across retail, wholesale, and distribution sectors.",
    privacyPolicy: "Privacy Policy",
    termsConditions: "Terms & Conditions",
    sitemap: "Sitemap",
    cookiePolicy: "Cookie Policy",
    privacyContent:
      "We only use your business information to provide software support, registration, and service communication. Your data is never sold to third parties.",
    termsContent:
      "By using Business Finance software, you agree to lawful use, account responsibility, and service terms related to updates, support, and licensing.",
    sitemapContent:
      "Main pages include Services, Features, Download, About, and Support with dedicated sections for product information and customer assistance.",
    cookieContent:
      "This website may use essential cookies to improve user experience, language preference, and theme selection for better accessibility.",
    footerTagline: "© 2026 Business Finance. All rights reserved | Made with Developer NK",
    locationDetail: "Khairpur Mir's, Sindh, Pakistan",
  },
  videoNoSupport: "Your browser does not support the video tag.",
  screenshotNames,
});

const urNav = {
  services: "خدمات",
  features: "خصوصیات",
  download: "ڈاؤن لوڈ",
  about: "ہمارے بارے میں",
  support: "سپورٹ",
};

const urHome = {
  ourServices: "ہماری خدمات",
  promoQuote: "اپنے کاروبار کو معیار فراہم کریں",
  downloadSuffix: "(32/64-bit)",
  marquee: urMarquee,
};

const urServices = {
  title: "خدمات",
  intro:
    "ریٹیل، ہول سیل، اور تقسیم کے لیے مکمل بزنس سافٹ ویئر خدمات سیٹ اپ، ٹریننگ، اور فروخت کے بعد تکنیکی سپورٹ کے ساتھ۔",
  cards: urServicesCards,
};

const urFeatures = {
  title: "خصوصیات",
  intro:
    "تمام قسم کے کاروباروں کے لیے کثیر المقاصد پوائنٹ آف سیل سافٹ ویئر۔ مہنگائی کے اس دور میں سستی قیمتوں پر بزنس فائنانس کاروباروں کے ساتھ مل کر ترقی کر رہا ہے۔",
  coreFeatures: "بنیادی خصوصیات",
  reports: "رپورٹس",
  included: "شامل",
  bottomBanner:
    "بزنس فائنانس آپ کے کاروبار کو منظم، منافع بخش، اور تیار رکھنے کے لیے بنایا گیا ہے۔",
  highlight1Title: "اسمارٹ بلنگ",
  highlight1Desc: "بار کوڈ اور محفوظ ریفنڈ کنٹرول کے ساتھ تیز انوائس۔",
  highlight2Title: "لائیو انوینٹری",
  highlight2Desc: "ریل ٹائم اسٹاک حرکت اور کم اسٹاک کی آگاہی۔",
  highlight3Title: "کاروباری بصیرت",
  highlight3Desc: "بہتر فیصلوں کے لیے روزانہ اور ماہانہ رپورٹس۔",
  featureItems: urFeatureItems,
  reportItems: urReportItems,
};

const urAboutPage = {
  founderProfile: "بانی کا تعارف",
  founderRole: "بزنس فائنانس سافٹ ویئر کنسلٹنٹ",
  founderBio:
    "ہم بڑھتے ہوئے کاروباروں کے لیے عملی اور قابل اعتماد سافٹ ویئر حل بناتے ہیں۔ ہمارا مقصد روزمرہ کے آپریشنز کو آسان بنانا اور صاف ڈیٹا اور اسمارٹ آٹومیشن کے ذریعے مالکان کو بہتر فیصلے کرنے میں مدد کرنا ہے۔",
  ourAim: "ہمارا مقصد",
  ourAimParagraph:
    "ہمارا مقصد ریٹیلرز، ہول سیلرز، اور تقسیم کاروں کو سستی اور ذہین بزنس مینجمنٹ ٹولز سے بااختیار بنانا ہے۔ ہم کمپنیوں کو انوینٹری کنٹرول، سیلز کی کارکردگی، اور مالی وضاحت میں اعتماد کے ساتھ بہتری لانے میں مدد کرنے کے پابند ہیں۔",
  companyExperienceTitle: "کمپنی کا تجربہ",
  companyExperienceBody:
    "ریٹیل، ہول سیل، اور تقسیم کے شعبوں میں متعدد مطمئن گاہکوں کے ساتھ بزنس سافٹ ویئر حل میں 10+ سال کا پیشہ ورانہ تجربہ ہے۔",
  yearsExperience: "سال تجربہ",
  happyBusinesses: "خوش کاروبار",
  customerSupport: "کسٹمر سپورٹ",
};

const urDownloadPage = { title: "ڈاؤن لوڈ" };

const urSupportPage = {
  title: "سپورٹ",
  heading: "آپ کے کاروبار کے لیے کسٹمر سپورٹ",
  intro:
    "رجسٹریشن، انسٹالیشن، یا تکنیکی مدد کے لیے فارم جمع کرائیں۔ ہم جلد از جلد جواب دیں گے۔",
  nameLabel: "نام*",
  emailLabel: "ای میل*",
  phoneLabel: "فون*",
  reasonLabel: "رابطے کی وجہ*",
  productLabel: "پروڈکٹ/سروس منتخب کریں*",
  uploadLabel: "مسئلے کا اسکرین شاٹ اپ لوڈ کریں (اختیاری)",
  messageLabel: "پیغام*",
  sendMessage: "پیغام بھیجیں",
  placeholderName: "اپنا نام درج کریں",
  placeholderEmail: "اپنی ای میل درج کریں",
  placeholderPhone: "فون نمبر درج کریں",
  placeholderMessage: "اپنا پیغام لکھیں",
  selectReason: "وجہ منتخب کریں",
  inquiry: "استفسار",
  contact: "رابطہ",
  selectProduct: "پروڈکٹ/سروس منتخب کریں",
  desktopApplication: "ڈیسک ٹاپ ایپلیکیشن",
  mobileApplication: "موبائل ایپلیکیشن",
  website: "ویب سائٹ",
  mapTitle: "خیرپور میرس کا نقشہ",
  supportAlt: "24/7 کسٹمر سپورٹ",
};

const urFooter = {
  locationMap: "لوکیشن کا نقشہ",
  companyExperience: "کمپنی کا تجربہ",
  companyExperienceText:
    "ریٹیل، ہول سیل، اور تقسیم کے شعبوں میں متعدد مطمئن گاہکوں کے ساتھ بزنس سافٹ ویئر حل میں 10+ سال کا پیشہ ورانہ تجربہ ہے۔",
  privacyPolicy: "رازداری کی پالیسی",
  termsConditions: "شرائط و ضوابط",
  sitemap: "سائٹ میپ",
  cookiePolicy: "کوکی پالیسی",
  privacyContent:
    "ہم صرف سافٹ ویئر سپورٹ، رجسٹریشن، اور سروس مواصلات کے لیے آپ کی کاروباری معلومات استعمال کرتے ہیں۔ آپ کا ڈیٹا کسی تیسرے فریق کو نہیں بیچا جاتا۔",
  termsContent:
    "بزنس فائنانس سافٹ ویئر استعمال کرتے ہوئے آپ قانونی استعمال، اکاؤنٹ کی ذمہ داری، اور اپ ڈیٹس، سپورٹ، اور لائسنس سے متعلق سروس کی شرائط سے اتفاق کرتے ہیں۔",
  sitemapContent:
    "مرکزی صفحات میں ہوم، خدمات، خصوصیات، ہمارے بارے میں، اور سپورٹ شامل ہیں پروڈکٹ کی معلومات اور کسٹمر امداد کے لیے مخصوص حصے۔",
  cookieContent:
    "یہ ویب سائٹ بہتر صارف تجربے، زبان کی ترجیح، اور بہتر رسائی کے لیے تھیم کے انتخاب کے لیے ضروری کوکیز استعمال کر سکتی ہے۔",
  footerTagline: "© 2026 بزنس فائنانس۔ تمام حقوق محفوظ ہیں | ڈیولپر NK کے ساتھ بنایا گیا",
  locationDetail: "خیرپور میرس، سندھ، پاکستان",
};

const sdNav = {
  services: "خدمتون",
  features: "خصوصيتون",
  download: "ڊائون لوڊ",
  about: "اسان بابت",
  support: "سپورٽ",
};

const sdHome = {
  ourServices: "اسان جون خدمتون",
  promoQuote: "پنهنجي ڪاروبار کي معيار فراهم ڪريو",
  downloadSuffix: "(32/64-bit)",
  marquee: sdMarquee,
};

const sdServices = {
  title: "خدمتون",
  intro:
    "ريٽيل، هول سيل، ۽ تقسيم لاءِ مڪمل بزنس سافٽ ويئر خدمتون سيٽ اپ، ٽريننگ، ۽ وڪرو کان پوءِ ٽيڪنيڪل سپورٽ سان.",
  cards: sdServicesCards,
};

const sdFeatures = {
  title: "خصوصيتون",
  intro:
    "سڀني قسم جي ڪاروبارن لاءِ گھڻن مقصدن وارو پوائنٽ آف سيل سافٽ ويئر. مهنگائيءَ جي هن دور ۾ سستي قيمتن تي بزنس فنانس ڪاروبارن سان گڏ واڌ ٿي رهيو آهي.",
  coreFeatures: "بنيادي خصوصيتون",
  reports: "رپورٽون",
  included: "شامل",
  bottomBanner:
    "بزنس فنانس توهان جي ڪاروبار کي منظم، منافع بخش، ۽ تيار رکڻ لاءِ ٺاهيو ويو آهي.",
  highlight1Title: "اسمارٽ بلنگ",
  highlight1Desc: "بار ڪوڊ ۽ محفوظ ريفنڊ ڪنٽرول سان تڪڙي انوائس.",
  highlight2Title: "لائيو انوينٽري",
  highlight2Desc: "ريل ٽائيم اسٽاڪ حرڪت ۽ گھٽ اسٽاڪ جي خبر.",
  highlight3Title: "ڪاروباري بصيرت",
  highlight3Desc: "بهتر فيصلا لاءِ روزاني ۽ مهيني رپورٽون.",
  featureItems: sdFeatureItems,
  reportItems: sdReportItems,
};

const sdAboutPage = {
  founderProfile: "باني جو تعارف",
  founderRole: "بزنس فنانس سافٽ ويئر ڪنسلٽنٽ",
  founderBio:
    "اسان وڌندڙ ڪاروبارن لاءِ عملي ۽ قابل اعتماد سافٽ ويئر حل ٺاهيون ٿا. اسان جو ڌيان روزمرهه جي آپريشنز کي آسان بڻائڻ ۽ صاف ڊيٽا ۽ اسمارٽ آٽوميشن ذريعي مالڪن کي بهتر فيصلا ڪرڻ ۾ مدد ڪرڻ تي آهي.",
  ourAim: "اسان جو مقصد",
  ourAimParagraph:
    "اسان جو مقصد ريٽيلرز، هول سيلرز، ۽ تقسيم ڪارن کي سستي ۽ ذهين بزنس مينيجمينٽ ٽولز سان بااختيار بڻائڻ آهي. اسان ڪمپنين کي انوينٽري ڪنٽرول، سيلز جي ڪارڪردگي، ۽ مالي وضاحت ۾ اعتماد سان بهتري آڻڻ ۾ مدد ڪرڻ لاءِ پرعزم آهيون.",
  companyExperienceTitle: "ڪمپني جو تجربو",
  companyExperienceBody:
    "ريٽيل، هول سيل، ۽ تقسيم جي شعبن ۾ گھڻن مطمئن گراهڪن سان بزنس سافٽ ويئر حل ۾ 10+ سالن جو پيشاورانه تجربو آهي.",
  yearsExperience: "سال تجربو",
  happyBusinesses: "خوش ڪاروبار",
  customerSupport: "ڪسٽمر سپورٽ",
};

const sdDownloadPage = { title: "ڊائون لوڊ" };

const sdSupportPage = {
  title: "سپورٽ",
  heading: "توهان جي ڪاروبار لاءِ ڪسٽمر سپورٽ",
  intro:
    "رجسٽريشن، انسٽاليشن، يا ٽيڪنيڪل مدد لاءِ فارم جمع ڪرايو. اسان جلدي جواب ڏينداسين.",
  nameLabel: "نالو*",
  emailLabel: "اي ميل*",
  phoneLabel: "فون*",
  reasonLabel: "رابطي جي وجه*",
  productLabel: "پروڊڪٽ/سروس چونڊيو*",
  uploadLabel: "مسئلي جو اسڪرين شاٽ اپ لوڊ ڪريو (اختياري)",
  messageLabel: "پيغام*",
  sendMessage: "پيغام موڪليو",
  placeholderName: "پنهنجو نالو لکو",
  placeholderEmail: "پنهنجي اي ميل لکو",
  placeholderPhone: "فون نمبر لکو",
  placeholderMessage: "پنهنجو پيغام لکو",
  selectReason: "وجه چونڊيو",
  inquiry: "استفسار",
  contact: "رابطو",
  selectProduct: "پروڊڪٽ/سروس چونڊيو",
  desktopApplication: "ڊيسڪ ٽاپ ايپليڪيشن",
  mobileApplication: "موبائل ايپليڪيشن",
  website: "ويب سائيٽ",
  mapTitle: "خيرپور ميرس جو نقشو",
  supportAlt: "24/7 ڪسٽمر سپورٽ",
};

const sdFooter = {
  locationMap: "لوڪيشن جو نقشو",
  companyExperience: "ڪمپني جو تجربو",
  companyExperienceText:
    "ريٽيل، هول سيل، ۽ تقسيم جي شعبن ۾ گھڻن مطمئن گراهڪن سان بزنس سافٽ ويئر حل ۾ 10+ سالن جو پيشاورانه تجربو آهي.",
  privacyPolicy: "رازداري جي پاليسي",
  termsConditions: "شرطون ۽ ضابطا",
  sitemap: "سائيٽ ميپ",
  cookiePolicy: "ڪوڪي پاليسي",
  privacyContent:
    "اسان صرف سافٽ ويئر سپورٽ، رجسٽريشن، ۽ سروس مواصلات لاءِ توهان جي ڪاروباري معلومات استعمال ڪيون ٿا. توهان جو ڊيٽا ڪنهن ٽئين پارٽي کي نه وڪيو ويندو آهي.",
  termsContent:
    "بزنس فنانس سافٽ ويئر استعمال ڪندي توهان قانوني استعمال، اڪائونٽ جي ذميواري، ۽ اپ ڊيٽس، سپورٽ، ۽ لائسنس سان لاڳاپيل سروس جي شرطن سان متفق ٿيو ٿا.",
  sitemapContent:
    "مرڪزي صفحن ۾ هوم، خدمتون، خصوصيتون، اسان بابت، ۽ سپورٽ شامل آهن پروڊڪٽ جي معلومات ۽ ڪسٽمر امداد لاءِ مخصوص سيڪشن.",
  cookieContent:
    "هي ويب سائيٽ بهتر يوزر تجربي، ٻولي جي ترجيح، ۽ بهتر رسائي لاءِ تھيم چونڊ لاءِ ضروري ڪوڪيز استعمال ڪري سگهي ٿي.",
  footerTagline: "© 2026 بزنس فنانس. سڀ حق محفوظ آهن | ڊولپر NK سان ٺاهيو ويو",
  locationDetail: "خيرپور ميرس، سنڌ، پاڪستان",
};

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: {
        title: "Business Finance",
        download: "Free Download",
        description:
          "Sales Automation, Inventory Control, Accounts Management, Reports in Seconds",
        about:
          "Business Finance is a complete POS & Inventory solution for multiple industries.",
        installationSteps: "Installation Steps",
        installationDescription:
          "Get started with Business Finance in just a few simple steps. Our streamlined installation process ensures you're up and running in minutes.",
        step1Title: "Download",
        step1Desc: "Download the setup file from our secure server",
        step2Title: "Install",
        step2Desc: "Run installer as Administrator for best results",
        step3Title: "Configure",
        step3Desc: "Follow on-screen instructions to configure",
        step4Title: "Launch",
        step4Desc: "Launch Business Finance from your Desktop",
        screenshots: "Screenshots",
        screenshotsDescription:
          "See Business Finance in action. Explore our intuitive interface and powerful features designed for modern businesses.",
        aboutTitle: "About Business Finance",
        professional: "Professional",
        professionalDesc: "Enterprise-grade security and reliability",
        fast: "Fast",
        fastDesc: "Lightning-fast performance and processing",
        accurate: "Accurate",
        accurateDesc: "Precise calculations and reporting",
        supportedOS: "Supported: Windows 7/8/10/11",
        fileSize: "File size: 3MB",
        companyName: "Business Finance",
        companyDescription:
          "Professional financial management software for modern businesses. Streamline your accounting and financial operations with our comprehensive solution.",
        contactInfo: "Contact Information",
        location: "Khairpur Mir's, Pakistan",
        email: "info.businessfinancepk@gmail.com",
        phone: "+92 314 5832291",
        followUs: "Follow Us",
        socialDescription: "Stay updated with our latest features and tutorials",
        copyright: "© 2026 Business Finance. All rights reserved",
        madeBy: "Made with Developer NK",
        dashboardTitle: "Business Finance Dashboard",
        screenshotCounter: "Screenshot",
        of: "of",
        videoTutorial: "Software Demo",
        freeTrial: {
          title: "Regsitration Form",
          back: "Back",
          pcModelSerialNumber: "PC Model/SerialNumber",
          windowsEditionSystemType: "Window Edition/System Type",
          companyName: "Company Name",
          userName: "User Name",
          address: "Address",
          contact: "Contact",
          remarks: "Remarks",
          projectExplanation: "Project Explanation",
          submit: "Submit",
          submitting: "Submitting...",
          detectAgain: "Detect Again",
          detecting: "Detecting...",
          detectSuccess: "System info has been detected.",
          detectError:
            "Local service is required for auto-detect. Run `npm start` and then click Detect Again.",
          submitSuccess: "Form submitted. Details have been sent to email.",
          submitError:
            "Automatic email could not be sent. Please try again or send it manually via email client.",
        },
        ...commonBundle(enServicesCards, enFeatureItems, enReportItems, enMarquee, enScreenshotNames),
      },
    },
    ur: {
      translation: {
        title: "بزنس فائنانس",
        download: "ڈاؤن لوڈ",
        description: "پوائنٹ آف سیل، انوینٹری، ویئرہاؤس، اسکول، میڈیکل اسٹورز",
        about:
          "بزنس فائنانس ایک مکمل پی او ایس اور انوینٹری سسٹم ہے مختلف انڈسٹریز کے لیے۔",
        installationSteps: "انسٹالیشن کے مراحل",
        installationDescription:
          "بزنس فائنانس کے ساتھ شروع کریں صرف چند آسان مراحل میں۔ ہمارا بہتر انسٹالیشن عمل یقینی بناتا ہے کہ آپ منٹوں میں کام کرنے کے قابل ہو جائیں۔",
        step1Title: "ڈاؤن لوڈ",
        step1Desc: "ہمارے محفوظ سرور سے سیٹ اپ فائل ڈاؤن لوڈ کریں",
        step2Title: "انسٹال",
        step2Desc: "بہترین نتائج کے لیے ایڈمنسٹریٹر کے طور پر انسٹالر چلائیں",
        step3Title: "کنفیگر",
        step3Desc: "کنفیگر کرنے کے لیے سکرین پر دی گئی ہدایات پر عمل کریں",
        step4Title: "لانچ",
        step4Desc: "اپنے ڈیسک ٹاپ سے بزنس فائنانس لانچ کریں",
        screenshots: "اسکرین شاٹس",
        screenshotsDescription:
          "بزنس فائنانس کو کام کرتے ہوئے دیکھیں۔ ہمارے بدیہی انٹرفیس اور طاقتور فیچرز کو دریافت کریں جو جدید کاروباروں کے لیے ڈیزائن کیے گئے ہیں۔",
        aboutTitle: "بزنس فائنانس کے بارے میں",
        professional: "پیشہ ورانہ",
        professionalDesc: "انٹرپرائز گریڈ سیکیورٹی اور قابل اعتماد",
        fast: "تیز",
        fastDesc: "بجلی کی طرح تیز کارکردگی اور پروسیسنگ",
        accurate: "درست",
        accurateDesc: "درست حساب کتاب اور رپورٹنگ",
        supportedOS: "سپورٹڈ: ونڈوز 7/8/10/11",
        fileSize: "فائل سائز: 3MB",
        companyName: "بزنس فائنانس",
        companyDescription:
          "جدید کاروباروں کے لیے پیشہ ورانہ مالیاتی انتظامی سافٹ ویئر۔ ہمارے جامع حل کے ساتھ اپنے اکاؤنٹنگ اور مالیاتی آپریشنز کو بہتر بنائیں۔",
        contactInfo: "رابطے کی معلومات",
        location: "خیرپور میرس، پاکستان",
        email: "info.businessfinancepk@gmail.com",
        phone: "+92 314 5832291",
        followUs: "ہمیں فالو کریں",
        socialDescription: "ہمارے تازہ ترین فیچرز اور ٹیوٹوریلز کے ساتھ اپڈیٹ رہیں",
        copyright: "© 2026 بزنس فائنانس۔ تمام حقوق محفوظ ہیں۔",
        madeBy: "ڈیولپر NK کے ساتھ بنایا گیا",
        dashboardTitle: "بزنس فائنانس ڈیش بورڈ",
        screenshotCounter: "اسکرین شاٹ",
        of: "کا",
        videoTutorial: "ویڈیو ٹیوٹوریل",
        freeTrial: {
          title: "فری ٹرائل اپلائی کریں",
          back: "واپس",
          pcModelSerialNumber: "پی سی ماڈل/سیریل نمبر",
          windowsEditionSystemType: "ونڈو ایڈیشن/سسٹم ٹائپ",
          companyName: "کمپنی کا نام",
          userName: "یوزر نام",
          address: "پتہ",
          contact: "رابطہ",
          remarks: "تفصیل",
          projectExplanation: "پروجیکٹ کی وضاحت",
          submit: "جمع کریں",
          submitting: "جمع ہو رہا ہے...",
          detectAgain: "دوبارہ ڈیٹیکٹ کریں",
          detecting: "ڈیٹیکٹ ہو رہا ہے...",
          detectSuccess: "سسٹم معلومات ڈیٹیکٹ ہو گئی ہیں۔",
          detectError:
            "آٹو ڈیٹیکٹ کے لیے لوکل سروس ضروری ہے۔ `npm start` چلائیں اور پھر دوبارہ ڈیٹیکٹ کریں۔",
          submitSuccess: "فارم جمع ہو گیا۔ تفصیلات ای میل پر بھیج دی گئی ہیں۔",
          submitError:
            "خودکار ای میل نہیں بھیجی جا سکی۔ دوبارہ کوشش کریں یا ای میل کلائنٹ سے دستی طور پر بھیجیں۔",
        },
        nav: urNav,
        home: urHome,
        services: urServices,
        features: urFeatures,
        aboutPage: urAboutPage,
        downloadPage: urDownloadPage,
        supportPage: urSupportPage,
        footer: urFooter,
        videoNoSupport: "آپ کا براؤزر ویڈیو ٹیگ سپورٹ نہیں کرتا۔",
        screenshotNames: urScreenshotNames,
      },
    },
    sd: {
      translation: {
        title: "بزنس فنانس",
        download: "ڊائون لوڊ",
        description: "پوائنٽ آف سيل، انوينٽري، گودام، اسڪول، ميڊيڪل اسٽورز",
        about: "بزنس فنانس هڪ مڪمل پي او ايس ۽ انوينٽري سسٽم آهي مختلف صنعتن لاءِ.",
        installationSteps: "انسٽاليشن جا مرحلا",
        installationDescription:
          "بزنس فنانس سان شروع ڪريو صرف ڪجهه آسان مرحلن ۾. اسان جو بھتر انسٽاليشن عمل يقيني بنائي ٿو ته توهان منٽن ۾ ڪم ڪرڻ جي قابل ٿي وڃو.",
        step1Title: "ڊائون لوڊ",
        step1Desc: "اسان جي محفوظ سرور کان سيٽ اپ فائل ڊائون لوڊ ڪريو",
        step2Title: "انسٽال",
        step2Desc: "بھترين نتيجن لاءِ ايڊمنسٽريٽر جي حيثيت سان انسٽالر هلائي",
        step3Title: "ڪنفيگر",
        step3Desc: "ڪنفيگر ڪرڻ لاءِ اسڪرين تي ڏنل هدايتن تي عمل ڪريو",
        step4Title: "لانچ",
        step4Desc: "پنهنجي ڊيسڪ ٽاپ کان بزنس فنانس لانچ ڪريو",
        screenshots: "اسڪرين شاٽس",
        screenshotsDescription:
          "بزنس فنانس کي ڪم ڪندي ڏسو. اسان جي بديهي انٽرفيس ۽ طاقتور فيچرز کي دريافت ڪريو جيڪي جديد ڪاروبارن لاءِ ڊيزائن ڪيا ويا آهن.",
        aboutTitle: "بزنس فنانس بابت",
        professional: "پيشاورانه",
        professionalDesc: "انٽرپرائز گريڊ سڪيورٽي ۽ قابل اعتماد",
        fast: "تيز",
        fastDesc: "بجليءَ جي ڀيٽ ۾ تيز ڪارڪردگي ۽ پروسيسنگ",
        accurate: "درست",
        accurateDesc: "درست حساب ڪتاب ۽ رپورٽنگ",
        supportedOS: "سپورٽ ڪيل: ونڊوز 7/8/10/11",
        fileSize: "فائل سائيز: 3MB",
        companyName: "بزنس فنانس",
        companyDescription:
          "جديد ڪاروبارن لاءِ پيشاورانه مالي انتظامي سافٽ ويئر. اسان جي جامع حل سان پنهنجي اڪائونٽنگ ۽ مالي آپريشنز کي بھتر بنايو.",
        contactInfo: "رابطي جي معلومات",
        location: "خيرپور ميرس، پاڪستان",
        email: "info.businessfinancepk@gmail.com",
        phone: "+92 314 5832291",
        followUs: "اسان کي فالو ڪريو",
        socialDescription: "اسان جي تازي ترين فيچرز ۽ ٽيوٽوريلز سان اپڊيٽ رهو",
        copyright: "© 2026 بزنس فنانس. سڀ حق محفوظ آهن.",
        madeBy: "ڊولپر NK سان ٺاهيو ويو",
        dashboardTitle: "بزنس فنانس ڊيش بورڊ",
        screenshotCounter: "اسڪرين شاٽ",
        of: "جو",
        videoTutorial: "ويڊيو ٽيوٽوريل",
        freeTrial: {
          title: "فري ٽرائل اپلاءِ ڪريو",
          back: "واپس",
          pcModelSerialNumber: "پي سي ماڊل/سيريل نمبر",
          windowsEditionSystemType: "ونڊو ايڊيشن/سسٽم ٽائپ",
          companyName: "ڪمپني جو نالو",
          userName: "يوزر نالو",
          address: "ائڊريس",
          contact: "رابطو",
          remarks: "تفصيل",
          projectExplanation: "پروجيڪٽ جي وضاحت",
          submit: "جمع ڪريو",
          submitting: "جمع ٿي رهيو آهي...",
          detectAgain: "ٻيهر ڊٽيڪٽ ڪريو",
          detecting: "ڊٽيڪٽ ٿي رهيو آهي...",
          detectSuccess: "سسٽم معلومات ڊٽيڪٽ ٿي وئي آهي.",
          detectError:
            "آٽو ڊٽيڪٽ لاءِ لوڪل سروس ضروري آهي. `npm start` هلائي پوءِ ٻيهر ڊٽيڪٽ ڪريو.",
          submitSuccess: "فارم جمع ٿي ويو. تفصيلون اي ميل تي موڪلي ويون آهن.",
          submitError:
            "خودڪار اي ميل موڪلي نه سگھجي. مهرباني ڪري ٻيهر ڪوشش ڪريو يا اي ميل ڪلائنٽ سان هٿرادو موڪليو.",
        },
        nav: sdNav,
        home: sdHome,
        services: sdServices,
        features: sdFeatures,
        aboutPage: sdAboutPage,
        downloadPage: sdDownloadPage,
        supportPage: sdSupportPage,
        footer: sdFooter,
        videoNoSupport: "توهان جو برائوزر ويڊيو ٽيگ سپورٽ نٿو ڪري.",
        screenshotNames: sdScreenshotNames,
      },
    },
  },
  lng: getInitialLanguage(),
  fallbackLng: "en",
  supportedLngs: SUPPORTED,
  load: "languageOnly",
  nonExplicitSupportedLngs: true,
  interpolation: { escapeValue: false },
  react: { useSuspense: false },
});

i18n.on("languageChanged", (lng) => {
  const code = normalizeLanguage(lng);
  if (typeof document !== "undefined") {
    document.documentElement.lang = code;
  }
});

const initial = normalizeLanguage(i18n.language);
if (typeof document !== "undefined") {
  document.documentElement.lang = initial;
}

export default i18n;
